// extracted by mini-css-extract-plugin
export default {"userAdElements":"UserAdElements_userAdElements__GLBP3"};